/**
 * The function express empty operate
 */
const noop=()=> {};
export default noop;


// WEBPACK FOOTER //
// ./src/noop.ts